module.exports = __webpack_public_path__ + "img/image-camp.3bc6be6e.jpg";